import instockImage from "@/assets/images/in-stock.png";
import expiredImage from "@/assets/images/export.png";
import manufacturedImage from "@/assets/images/manufactured.png";
import productValImage from "@/assets/images/product-value.png";
import { KeyValueObj } from "@/common/types";
import { formatToNaira } from "@/common/utils/general";

export const tableHeaders = [
  "Name",
  "Unit",
  "Strength",
  "Storage",
  "Qty",
  "Min Level",
  "Supply",
  "Selling Price",
];
export const tableKeys = [
  "name",
  "unit",
  "strength",
  "storage",
  "quantity",
  "minLevel",
  "supply",
  "selling_price",
];

// MED-652: product-aggregated inventory list — one row per product, replacing
// the per-batch table above as the primary inventory page view.
//
// MED-659 (UC-INV-02) widened it to the spec's columns: Unit is the packaging
// type of the holder's SELLING level (not the product form), Qty is counted at
// that level with the base-unit total as secondary text, and Selling Price shows
// the set price or "Not set" — never "₦0".
export const productInventoryTableHeaders = [
  "Product",
  "Status",
  "SKU",
  "Unit",
  "Strength",
  "Storage",
  "Qty",
  "Batches",
  "Min Level",
  "Supply",
  "Selling Price",
];
export const productInventoryTableKeys = [
  "product_name",
  "status",
  "sku",
  "unit",
  "strength",
  "storage",
  "quantity",
  "batch_count",
  "min_level",
  "supply",
  "selling_price",
];
export const tableData = [
  {
    name: "Adderal 5mg tabs",
    itemId: "MEDEX11122",
    unit: "TAB",
    storage: "A1.21",
    quantity: 300,
    minLevel: 20,
    supply: "In 5 days",
  },
  {
    name: "Chloroquin 5mg tabs",
    itemId: "MEDEX13422",
    unit: "CAP",
    storage: "A1.21",
    quantity: 300,
    minLevel: 20,
    supply: "In 19 days",
  },
  {
    name: "Paracetamol",
    itemId: "MEDEX55522",
    unit: "TAB",
    storage: "BC.21",
    quantity: 300,
    minLevel: 100,
    supply: "In 2 days",
  },
  {
    name: "Lemenfathrine 200mg",
    itemId: "MEDEX11122",
    unit: "PATCH",
    storage: "A1.21",
    quantity: 300,
    minLevel: 30,
    supply: "In 11 days",
  },
];

// ********* Old **********
export const inventoryForm2 = [
  {
    inputType: "number",
    prompt: `Quantity`,
    name: "quantity_received",
    placeholder: "Type the quantity to be added",
    fullWidth: false,
    rules: {
      aboveZero: {
        expectedValue: true,
        errorMessage: "Value must be greater than 0",
      },
    },
  },
  {
    inputType: "text",
    prompt: "Batch Number",
    name: "batch_number",
    placeholder: "Type the batch number",
    fullWidth: false,
    rules: {
      minLength: {
        errorMessage: "should be at least 2 characters",
        expectedValue: 2,
      },
    },
  },

  {
    inputType: "number",
    prompt: "Cost price per unit (NGN)",
    name: "cost_price_per_unit",
    placeholder: "Type the cost price per unit",
    fullWidth: false,
    rules: {
      aboveZero: {
        expectedValue: true,
        errorMessage: "Value must be greater than 0",
      },
    },
  },
  {
    inputType: "number",
    prompt: "Selling price per unit (NGN)",
    name: "selling_price_per_unit",
    placeholder: "Type the selling price per unit",
    fullWidth: false,
    rules: {
      aboveZero: {
        expectedValue: true,
        errorMessage: "Value must be greater than 0",
      },
    },
  },
  {
    inputType: "date",
    prompt: "Manufacture Date",
    name: "manufacture_date",
    placeholder: "Select manufacture date",
    fullWidth: false,
    rules: {
      notInTheFuture: {
        expectedValue: true,
        errorMessage: "Manufacture date cannot be in the future",
      },
    },
  },
  {
    inputType: "date",
    prompt: "Expiry Date",
    name: "expiry_date",
    placeholder: "Select expiry date",
    fullWidth: false,
    rules: {
      notInTheFuture: {
        expectedValue: false,
        errorMessage: "Product has expired",
      },
    },
  },
];

// ============ inventory sort fields (MED-719) =========== //
// `sortBy` values match PRODUCT_INVENTORY_SORT_OPTIONS on the backend
// (Api::V1::InventoriesController) exactly.
//
// MED-719 follow-up: this used to be 10 combined field+direction options
// ("Name (A-Z)", "Price (high to low)", ...). Team feedback was that this
// read as non-standard UI — split into a field list plus a separate
// direction toggle in the Table component, matching the usual "Sort by:
// [field] [asc/desc icon]" convention.
export const InventorySortFields = [
  { label: "Name", sortBy: "name" },
  { label: "Date created", sortBy: "date_created" },
  { label: "Expiry date", sortBy: "expiry_date" },
  { label: "Quantity", sortBy: "quantity" },
  { label: "Price", sortBy: "price" },
];

// ============ invertory filter params =========== //
export const InventoryFilterOptions = [
  {
    name: "manufacture_date",
    label: "Manufacturer Date",
    type: "date",
  },

  {
    name: "expiry_date",
    label: "Expiry Data",
    type: "date",
  },
  // {
  //   name: "status_term",
  //   label: "Delivery Status",
  //   type: "radio",
  //   options: [
  //     { label: "Accepted", value: "accepted" },
  //     { label: "Rejected", value: "rejected" },
  //     { label: "Completed", value: "completed" },
  //     { label: "Processed", value: "processed" },
  //     { label: "Canceled", value: "canceled" },
  //     { label: "Pending", value: "draft" },
  //     { label: "Failed", value: "failed" },
  //   ],
  // },
];

// ============== inventory form data =============== //
export const inventoryForm = [
  {
    inputType: "number",
    prompt: "Cost price per unit (NGN)",
    name: "cost_price_per_unit",
    placeholder: "Type the cost price per unit",
    fullWidth: false,
    rules: {
      aboveZero: {
        expectedValue: true,
        errorMessage: "Value must be greater than 0",
      },
    },
  },
  {
    inputType: "number",
    prompt: "Selling price per unit (NGN)",
    name: "selling_price_per_unit",
    placeholder: "Type the selling price per unit",
    fullWidth: false,
    rules: {
      aboveZero: {
        expectedValue: true,
        errorMessage: "Value must be greater than 0",
      },
    },
  },
  {
    inputType: "text",
    prompt: "Batch Number",
    name: "batch_number",
    placeholder: "Type the batch number",
    fullWidth: false,
    rules: {
      minLength: {
        errorMessage: "should be at least 2 characters",
        expectedValue: 2,
      },
    },
  },
  {
    inputType: "date",
    prompt: "Manufacture Date",
    name: "manufacture_date",
    placeholder: "Select manufacture date",
    fullWidth: false,
    rules: {
      notInTheFuture: {
        expectedValue: true,
        errorMessage: "Manufacture date cannot be in the future",
      },
    },
  },

  {
    inputType: "date",
    prompt: "Expiry Date",
    name: "expiry_date",
    placeholder: "Select expiry date",
    fullWidth: false,
    rules: {
      notInTheFuture: {
        expectedValue: false,
        errorMessage: "Expiry date cannot be in the past",
      },
    },
  },
  {
    inputType: "text",
    prompt: "Carton Serial No.",
    name: "carton_serial",
    placeholder: "Carton serial number",
    fullWidth: false,
  },
  {
    inputType: "text",
    prompt: "Pack Serial No.",
    name: "pack_serial",
    placeholder: "Carton serial number",
    fullWidth: false,
  },

  {
    inputType: "text",
    prompt: "Unit Serial No.",
    name: "unit_serial",
    placeholder: "Carton serial number",
    fullWidth: false,
  },
];

// MED-649: batch-detail fields for the complete-batch inventory Step 1 form.
// A dedicated array (not a trimmed `inventoryForm`) so the inventory-edit
// flow, which still derives its fields from `inventoryForm` via
// `actualInventoryForm`, is left untouched.
export const inventoryStep1Form = [
  {
    inputType: "text",
    prompt: "Batch Number",
    name: "batch_number",
    placeholder: "Type the batch number",
    fullWidth: false,
    rules: {
      minLength: {
        errorMessage: "should be at least 2 characters",
        expectedValue: 2,
      },
    },
  },
  // MED-686: cost and selling price are NOT declarative fields here. They are
  // fetched and pre-populated per product (the selling price comes from the
  // product's current listing, and its label names the seller's selling level),
  // so they live in <PricingDetails/>, rendered by InventoryStep1 above this
  // form. MED-659's "the seller is never asked for a cost price" still holds for
  // stock received against a platform purchase order — that component only shows
  // the cost field to manufacturers and importers, whose stock has no such order.
  {
    inputType: "date",
    prompt: "Manufacture Date",
    name: "manufacture_date",
    placeholder: "Select manufacture date",
    fullWidth: false,
    rules: {
      notInTheFuture: {
        expectedValue: true,
        errorMessage: "Manufacture date cannot be in the future",
      },
    },
  },
  {
    inputType: "date",
    prompt: "Expiry Date",
    name: "expiry_date",
    placeholder: "Select expiry date",
    fullWidth: false,
    rules: {
      notInTheFuture: {
        expectedValue: false,
        errorMessage: "Expiry date cannot be in the past",
      },
    },
  },
];

// HISTORY — the note below is kept because it explains a real bug, but its
// framing was wrong and MED-686 has reversed its conclusion. The removal was
// attributed to MED-675, which is a reliability bug ticket (step-state reset,
// details fetch, Clear controls) that never covered pricing; MED-659 §6
// "Harmonized price entry" actually asked FOR a level-labelled price field here.
// What was genuinely broken was the wiring — `selling_price_at_level` was sent
// to a backend that did not read it — and that is now fixed on both sides, so
// Step 1 collects pricing again via <PricingDetails/>.
//
// MED-675 — Step 1 used to also inject a price field here
// (`buildInventoryStep1Form`, name `selling_price_at_level`), but that value
// was spread straight into the inventory-create payload and silently
// dropped — the backend never read that key, only the older
// `selling_price_per_unit` this form had already stopped sending. Pricing is
// a product-wide concern, not a per-batch one, and now lives exclusively in
// the "Set selling level & price" flow (SellingLevelPriceModal /
// ProductListingService), reachable from the inventories list's row menu.

export interface ICardDetails {
  title: string;
  value: string;
  imageUrl: string;
  bg: string;
}

export function getCardDetails(data: any) {
  return [
    {
      title: "Total Products Value",
      value: formatToNaira(data?.total_products_value),
      imageUrl: productValImage,
      bg: "stat_1",
    },
    {
      title: "Total Products in Stock",
      value: data?.total_products_in_stock,
      imageUrl: instockImage,
      bg: "stat_2",
    },
    {
      title: "Manufactured Products",
      value: data?.total_products_manufactured,
      imageUrl: manufacturedImage,
      bg: "stat_3",
    },
    {
      title: "Total Expired Products",
      value: data?.total_expired_products,
      imageUrl: expiredImage,
      bg: "stat_4",
    },
  ];
}

export const getBarchartData = (barUserData: any) => ({
  labels: barUserData?.map((data: any) => data?.month),
  datasets: [
    {
      label: "Stock Value (in carton)",
      data: barUserData?.map((data: any) => data?.sales_value),
      backgroundColor: "#ECAF57",
      barThickness: 8,
    },
  ],
});

export const tableHeadersShort = [
  "Order Date",
  "Expected Delivery Date",
  "Payment Term",
  "Order Status",
  "Total Amount",
];
export const tableKeysShort = [
  "orderDate",
  "expectedDeliveryDate",
  "paymentTerm",
  "status",
  "totalAmount",
];
export const getRecentOrderTableData = (data: KeyValueObj[]) =>
  data?.map((datum: KeyValueObj) => ({
    status: { value: datum?.order_status, type: "string" },
    expectedDeliveryDate: {
      value: datum?.expected_delivery_date,
      type: "string",
    },
    orderDate: { value: datum?.created_at, type: "string" },
    paymentTerm: { value: datum?.payment_term, type: "string" },
    totalAmount: { value: formatToNaira(datum?.total_amount), type: "string" },
    id: datum?.id,
  }));
